<script lang="ts">
  import { Col, FormGroup, Label } from "sveltestrap";
  import { Inlinecheckbox, Option } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <h5>{Inlinecheckbox}</h5>
</Col>
<Col>
  <FormGroup class="m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
    <div class="radio radio-primary">
      <input id="radioinline1" type="radio" name="radio1" value="option1">
      <Label class="mb-0" for="radioinline1">{Option}<span class="digits"> 1</span></Label>
    </div>
    <div class="radio radio-primary">
      <input id="radioinline2" type="radio" name="radio1" value="option1">
      <Label class="mb-0" for="radioinline2">{Option}<span class="digits"> 2</span></Label>
    </div>
    <div class="radio radio-primary">
      <input id="radioinline3" type="radio" name="radio1" value="option1">
      <Label class="mb-0" for="radioinline3">{Option}<span class="digits"> 3</span></Label>
    </div>
  </FormGroup>
</Col>